<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.dialogs.upload_invoice_header') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form ref="ruleForm" class="h-full flex flex-col" :model="form" :rules="rules">
          <div class="lg:mb-2" v-if="[3, 8].includes(role)">
            <label
              class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('clients.entity_name') }}</label>
            <el-form-item prop="ClienteID" class="mb-0">
              <base-el-select class="w-full" :options="clientes" v-model="form.ClienteID" filterable clearable @change="handleChangeClienteId" />
            </el-form-item>
          </div>
          <section>
            <template v-if="form.ClienteID">
              <div class="lg:flex files-container">
                <div class="main-files-container max-w-md">
                  <div class="flex items-center mb-1">
                    <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon />{{
                      $t('invoices.doc_factura') }}</label>
                    <base-tooltip-icon size="sm" :content="extensionTooltipFacturaeMessage" class="ml-2 " />
                  </div>
                  <div class="px-2">
                    <el-form-item prop="fileMain" ref="fileMainRef">
                      <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileMainDrop">
                        <Upload ref="uploadMain" id="fileMainSelector" class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="acceptFiles"
                        drag action="#" :auto-upload="false" :on-remove="handleRemoveMain" multiple :limit="pgeUploadLimitComputed"
                        :on-change="handleChangeMain" :on-exceed="handleOnExceedMain" :file-list="form.fileMain">
                        <i class="el-icon-upload"></i>
                        <p v-if="form.fileMain.length" slot="default" class="el-upload__text"><em>{{ this.fileNameMain }}</em></p>
                        <div v-else slot="default" class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', pgeUploadLimitComputed)"></div>
                        <upload-file-item slot="file" slot-scope="{file}" :file="file" :actions="[{name: 'addattachment-border', handler: selectFile, show: showAddAttachments /* && false */}]" parent-height="67px"
                          :hide-expand-action="file.validations && file.validations.some(v => v.type === ErrorType.DUPLICATED_FILE)" :deep="2" custom="!max-h-fit" @remove="handleRemoveMain" @click="selectFile" reverse-colors />
                        </Upload>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div v-if="selectedFile" class="file-attachments-container max-w-md">
                  <div class="flex items-center mb-1" :style="{ width: itemWidth }">
                    <base-obligatory-icon class="invisible" />
                    <el-tooltip placement="top-end">
                      <div slot="content" class="max-w-sm max-h-500p overflow-auto">
                        {{ selectedFile.path || selectedFile.name }}
                      </div>
                      <span class="tooltip-icon__icon-wrap truncate">
                        <label class="text-sm font-semibold text-secondary-600 block truncate">{{ attachmentsText }}</label>
                      </span>
                    </el-tooltip>
                    <base-tooltip-icon-multiple size="sm" :content="extensionTooltipMessage" class="ml-2 " />
                  </div>
                  <div ref="upload-file-wrap" class="px-2" :style="{ width: 'fit-content' }">
                    <el-form-item prop="file" ref="fileRef">
                      <div @dragenter="e => e.preventDefault()" @dragover="e => e.preventDefault()" @drop.prevent.stop="onFileDrop">
                        <Upload ref="upload" id="fileSelector" class="bg-white dark:bg-darkblue-900" :show-file-list="false"
                          :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']" :accept="acceptAdjuntosExternos" drag
                          multiple action="#" :auto-upload="false" :on-remove="handleRemove" :limit="maxFilesAdjWithRequired"
                          :on-change="handleChange" :on-exceed="handleOnExceed" :file-list="form.file" :disabled="form.fileMain.length > 1 && false ">
                          <i class="el-icon-upload"></i>
                          <p v-if="form.file.length" class="el-upload__text"><em>{{ fileName }}</em></p>
                          <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', maxFilesAdjWithRequired)"></div>
                        </Upload>
                        <template v-for="file in expandedFiles">
                          <upload-file-list v-if="file.linkid === selectedFile.linkid && file.uid === selectedFile.uid" :key="file.linkid + file.uid" :files="attachments.filter(efile => (efile.linkedfile && efile.linkedfile.linkid === file.linkid && efile.linkedfile.uid === file.uid))"
                            max-height="67px" :actions="[{name: 'error', handler: clearRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided && !!efile.raw}, {name: 'addattachment-border', handler: selectRequiredFile, show: efile => efile.required && !efile.IsAlreadyProvided}]" :hide-default-item-actions-callback="efile => efile.required || efile.IsAlreadyProvided" 
                            :hide-status-item-callback="efile => !efile.required" @remove-file="handleRemove" :item-click-listener-callback="efile => efile.required && !efile.IsAlreadyProvided ? {click: selectRequiredFile} : {}" />
                          </template>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div v-if="form.file && form.file.length > 0" class="all-attachments-container w-full">
                  <div class="flex items-center mb-1 invisible">
                    <label class="text-sm font-semibold text-secondary-600 block w-0 truncate">{{ allAttachmentsText }}</label>
                  </div>
                  <upload-file-list key="attachments-list" class="grid gap-4" :class="allAttachmentsListClass" :files="attachments" max-height="calc(100% - 20px)" :hide-status-item-callback="efile => !efile.required" hide-default-actions />
                </div>
              </div>
              <div class="flex w-full mt-2 mb-3">
                <div class="flex items-center gap-x-2 justify-center w-full max-w-md">
                  <label class="text-sm text-secondary-600 block mb-1">{{ $t('imports.template_to_import') }}</label>
                  <base-button-icon
                    :aria-label="$t('imports.download_template')"
                    @click="downloadTemplate"
                    size="xs"
                    name="download"
                    class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full inline-block"
                  />
                </div>
                <div class="w-full lg:block hidden"><!-- PAD para el botón de descargar plantilla --></div>
                <div class="w-full lg:block hidden"><!-- PAD para el botón de descargar plantilla --></div>
              </div>
            </template>
            <div class="lg:mb-2 w-full flex gap-4">
              <div class="w-full" v-if="form.fileMain && form.fileMain.length > 0">
                <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.pge_type') }}</label>
                <el-form-item prop="pgeType">
                  <base-el-select class="w-full" :options="pgeTypes" v-model="form.pgeType" filterable clearable :disabled="!isExcelFile && !!selectPge"/>
                </el-form-item>
              </div>
              <div class="w-full" v-if="form.fileMain && form.fileMain.length > 0">
                <label
                  class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('invoices.cif_emisor') }}</label>
                <el-form-item prop="CifEmpresa">
                  <base-el-select class="w-full" :options="CifsEmpresa" v-model="form.CifEmpresa" filterable clearable :option-label="cifLabelOption" :option-value="cifValueOption" :loading="isCifEmisorLoading" :loading-text="cifEmisorLoadingText" :disabled="!!selectCif" />
                  <div v-if="isExcelFile" class="mt-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('tooltip.upload_invoice_pge') }}</label>
                  </div>
                </el-form-item>
              </div>
              <div v-if="signatureConfig">
                <label style="visibility: hidden;"
                  class="text-sm font-semibold text-secondary-600 block mb-5"></label>
                <base-button-icon name="config" mode="secondary-phantom" @click="openSignatureDialog()" />
              </div>
            </div>
            <div class="lg:mb-2" v-if="form.pgeType || multiSend">
              <el-switch v-if="form.pgeType" class="switch-text break-normal" v-model="form.sendAuto" :active-text="$t('app.send_auto')"></el-switch>&nbsp;
              <el-switch v-if="multiSend" class="switch-text break-normal" v-model="form.sendMail" :active-text="$t('app.send_mail')"></el-switch>
            </div>
          </section>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button :disabled="disableSubmit" :loading="isLoadingUpdate" mode="secondary-phantom-blue" class="w-full mx-2"
        :text="$tc('invoices.dialogs.upload_invoice', 1)" @click="submitForm('ruleForm')" />
      </div>
      <Dialog :title="$t('companies.configuration.config_firma_needed')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center append-to-body>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage2 }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { gotoSignatureConfig(); showModal = false }" />
          </div>
        </template>
      </Dialog>
    </template>
  </base-dialog-button>
</template>

<script>
import UploadDocumentMixin, { WarningType, ErrorType } from '@/mixins/UploadDocumentMixin'

import { getClients } from '@/services/clients/getClients'
import { getcifspermisos } from '@/services/companies/getcifspermisos'

import { subirFactura } from '@/services/invoices/subirFactura'
import { descargarficherofacturasexcel } from '@/services/invoices/descargarficherofacturasexcel'

import { Dialog, Upload } from 'element-ui'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJ_EXTERNOS, EXTENSIONES_ADJ_EXTERNOS_FACEB2B } from '@/config/extensiones-adj-externos'
import { EXTENSIONES_FACTURAE } from '@/config/extensiones-facturae'
import UploadFileItem from '@/components/UploadFileItem.vue'
import UploadFileList from '@/components/UploadFileList.vue'

export default
{
  name: 'upload-issued-invoice-dialog',
  mixins: [UploadDocumentMixin],
  components: {
    Dialog,
    Upload,
    UploadFileItem,
    UploadFileList,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      WarningType,
      ErrorType,
      isLoadingUpdate: false,
      loading: false,
      isOpen: this.dialogOpen,
      itemWidth: 'fit-content',
      form: this.getDefaultForm(),
      selectCif: '',
      selectPge: '',
      currentSchema: '',
      selectedFile: null,
      pgeUploadLimit: 30,
      maxFilesAdj: 5,
      maxSizeFile: 7340032, // Bytes (7MB)
      clientes: [],
      CifsEmpresa: [],
      noSignatureConfig: ['EMAIL', 'EXTERNO'],
      showModal: false,
      waitingToShow: false,
      processMessage: i18n.t('invoices.dialogs.upload_invoice_modal_message'),
      processMessage2: i18n.t('app.lose_unsaved_data'),
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJ_EXTERNOS,
      extensionesAdjuntosFaceb2b: EXTENSIONES_ADJ_EXTERNOS_FACEB2B,
      extensionesFacturaePermitidas: EXTENSIONES_FACTURAE,
      rules: {
        ClienteID: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        pgeType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
        fileMain: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain || this.fileNameMain.length < 5 || !this.fileNamesMain.every(name => ['XML', 'XSIG', 'XLSX', 'TXT', 'ZIP'].includes(this.getExtensionFromFileName(name).toUpperCase()))) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig', '.xlsx', '.txt'], true) })))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
              if (exts.some(x => x === 'ZIP')) {
                if (exts.length > 1) {
                  callback(new Error(i18n.t('validation.onlyonce_zip')))
                } else {
                  callback()
                }
              } else if (!exts.every(x => this.extensionesFacturaePermitidas.includes(x))) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig', '.txt'], true) })))
              } else {
                callback()
              }
            }
          }
        ],
        file: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileName) {
                let totalSize = 0
                this.form.file.forEach(x => {
                  totalSize = totalSize + x.size
                })
                if (totalSize > this.maxSizeFile) {
                  callback(new Error(i18n.t('validation.exceed_size_files_total') + ' (' + this.maxMBAdj + ' MB)'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.form.file.forEach(archivo => {
                const extension = this.getExtensionFromFileName(archivo.name).toUpperCase()
                if (this.form.pgeType === 'FACEB2B') {
                  if (!this.extensionesAdjuntosFaceb2b.includes(extension)) {
                    invalidExtension = true
                  }
                  if (extension === 'ZIP' && this.form.file.length > 1) {
                    invalidExtension = true
                  }
                } else {
                  if (!this.extensionesAdjuntosPermitidas.includes(extension)) {
                    invalidExtension = true
                  }
                }
              })
              if (invalidExtension) {
                callback(new Error(this.extensionRuleMessage))
              } else {
                callback()
              }
            }
          },
        ],
        CifEmpresa: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ],
      },
      schemasFiles: {
        TXT: 0,
        ZCPGE: 0,
        EXCEL: 0,
        ESQZCPGE: 0,
        ROCHLING: 0,
        FACTURAE: 0,
        NO_VALID: 0,
      },
    }
  },
  watch: {
    // Inicializar al abrir el componente
    'form.CifEmpresa': function (value, oldValue) {
      if (value !== oldValue) {
        this.updateWarningStatus(WarningType.MISSING_CIF, !!value, file => ['ZCPGE', 'EXCEL'].includes(file.esquema))
      }
    },
    selectCif: function (value, oldValue) {
      if (value !== oldValue) {
        this.form.CifEmpresa = value || ''
      }
    },
    selectPge: function (value, oldValue) {
      if (value !== oldValue) {
        this.form.pgeType = value || ''
      }
    },
    cifEmpresaSelected: function (value, oldValue) {
      if (this.isEmitida && value?.IdCIFEmpresa !== oldValue?.IdCIFEmpresa) {
        if (value) {
          if (value.HasVerifactuActive) {
            if (!value.HasCertificateActive) {
              this.openSignatureDialog(i18n.t('feedback.error.missing_signature_config_for_verifactu_error', { name: value.RazonSocial }))
            }
          } else if (this.form.pgeType) {
            if (!value.HasCertificateActive && !this.noSignatureConfig.includes(this.form.pgeType) && this.form.fileMain.some(file => !file.isSigned)) {
              this.openSignatureDialog(i18n.t('feedback.error.missing_signature_config_for_pge_error', { name: value.RazonSocial }))
            }
          }
        }
        this.updateValidationStatus(ErrorType.MISSING_SIGNATURE_CONFIG_ERROR, file => {
          if (!value || !this.form.pgeType) return true
          const { HasVerifactuActive, HasCertificateActive } = value
          if (HasVerifactuActive) return HasCertificateActive
          return file.isSigned || HasCertificateActive || this.noSignatureConfig.includes(this.form.pgeType)
        })
      }
    },
    'form.pgeType': function (value, oldValue) {
      if (value !== oldValue) {
        if (value) {
          const empresa = this.cifEmpresaSelected
          if (empresa) {
            if (empresa.HasVerifactuActive) {
              if (!empresa.HasCertificateActive) {
                this.openSignatureDialog(i18n.t('feedback.error.missing_signature_config_for_verifactu_error', { name: empresa.RazonSocial }))
              }
            } else {
              if (!empresa.HasCertificateActive && !this.noSignatureConfig.includes(value) && this.form.fileMain.some(file => !file.isSigned)) {
                this.openSignatureDialog(i18n.t('feedback.error.missing_signature_config_for_pge_error', { name: empresa.RazonSocial }))
              }
            }
          }
        }
        this.updateValidationStatus(ErrorType.MISSING_SIGNATURE_CONFIG_ERROR, file => {
          if (!this.cifEmpresaSelected || !value) return true
          const { HasVerifactuActive, HasCertificateActive } = this.cifEmpresaSelected
          if (HasVerifactuActive) return HasCertificateActive
          return file.isSigned || HasCertificateActive || this.noSignatureConfig.includes(value)
        })
      }
    },
  },
  mounted: async function () {
  },
  computed: {
    SchemaForType: function () {
      return this.tiposEsquema.filter(x => x.types.includes('issued')).map(x => x.esquema)
    },
    disableSubmit: function () {
      var disable = Object.values(this.form).filter(x => typeof x !== 'boolean').reduce((a, b) => a || (!b && b !== 0), false)

      disable ||= this.form.fileMain.some(file => file.validations?.some(validation => !validation.fixed) || file.files?.some(efile => efile.validations?.some(validation => !validation.fixed)))
      disable ||= this.form.fileMain.some(file => file.warns?.some(warn => !warn.fixed) || file.files?.some(efile => efile.warns?.some(warn => !warn.fixed)))
      disable ||= (this.isZCPGE || this.isExcelFile) && !this.form.CifEmpresa

      return this.isLoadingUpdate || disable
    },
    isCifEmisorLoading: function () {
      return !!(this.loading || ((this.isZCPGE || this.isExcelFile) && this.isSuperAdminOrDistributor && !this.form.ClienteID))
    },
    cifEmisorLoadingText: function () {
      return this.isZCPGE && !this.form.ClienteID ? i18n.t('validation.wait_idcliente') : undefined
    },
    isZCPGE: function () {
      return this.schemasFiles.ZCPGE > 0 && this.currentSchema === 'ZCPGE'
    },
    isExcelFile: function () {
      return this.schemasFiles.EXCEL > 0 && this.currentSchema === 'EXCEL'
    },
    pgeUploadLimitComputed: function () {
      return this.form.fileMain.some(x => this.getExtensionFromFileName(x.name).toUpperCase() === 'ZIP') ? 1 : this.pgeUploadLimit
    },
    
    acceptFiles: function () {
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
      if (exts.length === 0) {
        return '.xml,.xsig,.xlsx,.txt,.zip'
      }
      return exts.some(x => ['XML', 'XSIG', 'XLSX', 'TXT'].includes(x)) ? '.xml,.xsig,.xlsx,.txt' : '.zip'
    },
    disableAdjuntosExternos () {
      return this.form.pgeType === 'OSAKIDETZA'
    },
    acceptAdjuntosExternos () {
      if (this.form.pgeType === 'FACEB2B') return '.xml,.xsig,application/pdf,application/zip'
      return '.pdf,.html'
    },
    maxMBAdj () {
      return this.maxSizeFile / 1024 / 1024
    },
    extensionRuleMessage: function () {
      if (this.form.pgeType === 'FACEB2B') {
        return `${i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') })} ${i18n.t('validation.onlyonce_zip')}`
      }
      return i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
    },
    extensionTooltipMessage: function () {
      var maxFileMsg = this.form.pgeType === 'FACEB2B' ? i18n.t('validation.max_files_faceb2b', { maxFilesAdj: this.maxFilesAdj }) : i18n.t('validation.max_files', { maxFilesAdj: this.maxFilesAdj })
      var maxSizeMsg = i18n.t('validation.max_size_files', { maxMBAdj: this.maxMBAdj })
      var lines = [maxFileMsg + ' ' + maxSizeMsg]
      if (this.form.pgeType === 'FACEB2B') {
        lines.push(i18n.t('validation.extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') }))
      } else {
        lines[0] += ' ' + i18n.t('validation.extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
      }
      if (this.disableAdjuntosExternos) {
        lines.push(i18n.t('invoices.dialogs.remove_facturae_sign_advice'), i18n.t('invoices.dialogs.embeded_atachments_advice'))
      }
      return lines
    },
    extensionTooltipFacturaeMessage: function () {
      // const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase())
      // const validExts = exts.length === 0 ? [...this.extensionesFacturaePermitidas, 'ZIP'] : (exts.some(x => x === 'ZIP') ? ['ZIP'] : this.extensionesFacturaePermitidas)
      return `${i18n.t('validation.emitidas_formats')} ${i18n.t('tooltip.total_max_size_files', { maxMB: this.maxMBAdj })}`
    },
    attachmentsText () {
      if (this.selectedFile?.path) {
        return !this.disableAdjuntosExternos ? this.$t('invoices.documents_adj_ext_of', { name: this.selectedFile.path }) : this.$t('invoices.documents_adj_of', { name: this.selectedFile.path })
      }
      if (this.selectedFile?.name) {
        return !this.disableAdjuntosExternos ? this.$t('invoices.documents_adj_ext_of', this.selectedFile) : this.$t('invoices.documents_adj_of', this.selectedFile)
      }
      return !this.disableAdjuntosExternos ? this.$t('invoices.documents_adj_ext') : this.$t('invoices.documents_adj')
    },
    allAttachmentsText () {
      return !this.disableAdjuntosExternos ? this.$t('invoices.all_documents_adj_ext') : this.$t('invoices.all_documents_adj')
    },
    cifEmpresaSelected: function () {
      return this.CifsEmpresa.find(x => x.IdCIFEmpresa === this.form.CifEmpresa)
    },
    // isSignatureConfig: function () {
    //   return !!this.$store.getters['app/isInMode'](6)
    // },
    signatureConfig: function () {
      if (!this.cifEmpresaSelected) {
        return false
      }
      const { HasVerifactuActive, HasCertificateActive } = this.cifEmpresaSelected
      return !HasCertificateActive && (HasVerifactuActive || (this.form.pgeType && !this.noSignatureConfig.includes(this.form.pgeType) && this.form.fileMain.some(file => !file.isSigned)))
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
  },
  methods: {
    getSchemaRequestParams (idCliente) {
      const params = { isReceived: false }
      if ([3, 8].includes(this.role)) params.idCliente = idCliente
      return params
    },
    addSchemaValidationError (file, error, sort) {
      if (['GTOSH003', 'GTOSH004'].includes(error.errorPath)) {
        this.addValidation(file, i18n.t('invoices.dialogs.upload_invoice_file_require_signature'), ErrorType.MISSING_SIGNATURE_CONFIG_ERROR, undefined, false, sort)
      } else {
        this.addValidation(file, error.validationMessage, ErrorType.SCHEMA_VALIDATION_ERROR, error.errorPath, false, sort)
      }
    },

    getDefaultForm: function () {
      return {
        ClienteID: '',
        sendAuto: false,
        sendMail: false,
        pgeType: '',
        fileMain: [],
        file: [],
        CifEmpresa: '',
      }
    },
    handleChangeClienteId: async function (ClienteID) {
      if (ClienteID) {
        this.updateClientCifs(ClienteID)
        this.updateSchemaFiles(ClienteID)
      } else {
        this.CifsEmpresa = []
      }
    },
    handleChangeMain: async function (archivo) {
      (this.$refs.fileMainRef).clearValidate()
      let fileOk = true
      const exts = this.fileNamesMain.map(name => this.getExtensionFromFileName(name).toUpperCase()).concat(this.getExtensionFromFileName(archivo.name).toUpperCase())
      if (exts.some(x => x === 'ZIP')) {
        if (exts.length > 1) {
          this.doFeedback(i18n.t('validation.onlyonce_zip'))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else {
          await this.checkSchemaZipFile(archivo)
        }
      } else {
        if (!this.extensionesFacturaePermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
          this.doFeedback(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.xml', '.xsig', '.xlsx', '.txt'], true) }))
          this.handleRemoveMain(archivo)
          fileOk = false
        } else {
          await this.checkSchemaFile(archivo)
          if ((this.form.fileMain.length + 1) === 1 && !archivo.files?.length && !archivo.validations?.length) {
            this.selectFile(archivo)
          }
        }
      }
      
      if (fileOk) {
        this.form.fileMain.push(archivo)
      }
    },
    handleChange: function (archivo) {
      this.$refs.fileRef.clearValidate()

      const extension = this.getExtensionFromFileName(archivo.name).toUpperCase()
      var error = false
      if (this.form.pgeType === 'FACEB2B') {
        if (!this.extensionesAdjuntosFaceb2b.includes(extension)) {
          error = i18n.t('validation.not_valid_extension', { exts: this.extensionesAdjuntosFaceb2b.join(', ') })
        }
        if ((extension === 'ZIP' || this.form.file.map(x => this.getExtensionFromFileName(x.name).toUpperCase()).includes('ZIP')) && this.form.file.length >= 1) {
          error = i18n.t('validation.not_faceb2b_zip')
        }
      } else {
        if (!this.extensionesAdjuntosPermitidas.includes(extension)) {
          error = i18n.t('validation.not_valid_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
        }
      }
      if (error && error !== '') {
        this.doFeedback(error)
        this.handleRemove(archivo)
      } else {
        if (this.selectedFile) {
          this.$set(archivo, 'linkedfile', this.selectedFile)
        } else if (this.form.fileMain.length === 1) {
          this.$set(archivo, 'linkedfile', this.form.fileMain[0])
        }
        const mainFile = this.expandedFiles.find(x => x.linkid === archivo.linkedfile.linkid && x.uid === archivo.linkedfile.uid)
        if (mainFile?.reqAttachments?.some(x => x.AttachmentFormalName === archivo.name)) {
          const requireds = mainFile.reqAttachments.filter(x => x.AttachmentFormalName === archivo.name)
          const attachment = this.form.file.find(x => requireds.some(required => x.attachmentid === required.UniqueIdentifierAttachment) && !x.raw)
          if (attachment) {
            this.$set(attachment, 'successmsg', archivo?.name)
            this.$set(attachment, 'showinfo', !archivo?.raw)
            this.$set(attachment, 'raw', archivo.raw)
            this.expandedFiles.filter(x => x.linkid === attachment.linkedfile.linkid).forEach(x => this.$set(x, 'showinfo', this.form.file.filter(att => att.linkedfile.linkid === x.linkid).some(att => att.showinfo)))
            this.updateAttachmentWarningStatus(WarningType.MISSING_ATTACHMENT, !!archivo.raw, file => file.attachmentid === attachment.attachmentid, warn => warn.attachmentid === attachment.attachmentid)
            this.handleRemove(archivo)
          } else {
            const attachmentExt = this.getExtensionFromFileName(requireds[0].UniqueIdentifierAttachment)
            const attachmentKey = requireds[0].UniqueIdentifierAttachment.substring(0, requireds[0].UniqueIdentifierAttachment.lastIndexOf('.'))
            const attachmentCount = this.form.file.filter(x => x.name === archivo.name && x.linkedfile.linkid === archivo.linkedfile.linkid && x.linkedfile.uid === archivo.linkedfile.uid).length
            this.$set(archivo, 'attachmentid', `${attachmentKey}_${attachmentCount}.${attachmentExt}`)
            this.$set(archivo, 'origin', `user.${archivo.uid}`)
            this.form.file.push(archivo) 
          }
        } else {
          this.$set(archivo, 'origin', `user.${archivo.uid}`)
          this.form.file.push(archivo) 
        }
      }
    },
    handleOnExceedMain: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.pgeUploadLimitComputed }), 'warning')
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFilesAdj }), 'warning')
    },
    handleRemoveMain: function (file) {
      this.form.fileMain = this.form.fileMain.filter(x => x.uid !== file.uid)
      const isZipFile = file.linkid === 'ZIPFILE'
      if (file.esquema) {
        if (file.esquema === 'Variado') {
          if (file.files?.length) {
            file.files.forEach(x => { if (x.esquema) { this.schemasFiles[x.esquema] = Math.max(this.schemasFiles[x.esquema] - 1, 0) } })
          }
        } else {
          let n = 1
          let esquema = file.esquema
          if (isZipFile) {
            n = file.files?.length ?? 0
            esquema = file.esquema.slice(0, -1)
          }
          this.schemasFiles[esquema] = Math.max(this.schemasFiles[esquema] - n, 0)
          if (this.schemasFiles[esquema] < 1 && this.currentSchema === esquema) {
            let schema = ''
            this.updateValidationStatus(ErrorType.MISCELANEUS_SCHEMA_ERROR, efile => (schema ||= (efile.esquema && efile.esquema !== 'NO_VALID' ? efile.esquema : '')) === efile.esquema)
            this.currentSchema = schema
          }
        }
      }
      const matchCif = isZipFile 
        ? file.files.some(efile => this.selectCif === efile.IdCifEmpresa) 
        : this.selectCif === file.IdCifEmpresa
      if (this.selectCif && matchCif && !this.expandedFiles.some(efile => efile.IdCifEmpresa === this.selectCif)) {
        let idCIFEmpresa = ''
        this.updateValidationStatus(ErrorType.MISCELANEUS_CIF_ERROR, efile => (idCIFEmpresa ||= (efile.IdCifEmpresa && efile.esquema === this.currentSchema ? efile.IdCifEmpresa : '')) === efile.IdCifEmpresa)
        this.selectCif = idCIFEmpresa
      }
      const matchPge = isZipFile 
        ? file.files.some(efile => this.selectPge === efile.pgeType) 
        : this.selectPge === file.pgeType
      if (this.selectPge && matchPge && !this.expandedFiles.some(efile => efile.pgeType === this.selectPge)) {
        let pgeType = ''
        this.updateValidationStatus(ErrorType.MISCELANEUS_PGE_ERROR, efile => (pgeType ||= (efile.pgeType && efile.esquema === this.currentSchema ? efile.pgeType : '')) === efile.pgeType)
        this.selectPge = pgeType
      }
      if (this.selectedFile?.linkid === file.linkid && this.selectedFile?.uid === file.uid) {
        this.selectedFile = null
      }
      if (file.files?.length) {
        for (const efile of file.files) {
          if (this.selectedFile?.linkid === efile.linkid && this.selectedFile?.uid === efile.uid) {
            this.selectedFile = null
          }
          // this.form.file.filter(x => x.linkedfile.uid === efile.uid).forEach(x => this.handleRemove(x))
        }
      }
      this.form.file.filter(x => x.linkedfile.uid === file.uid).forEach(x => this.handleRemove(x))
      const duplicated = this.form.fileMain.filter(x => x.linkid === file.linkid)
      if (duplicated.length) {
        if (duplicated.every(x => x.validations?.some(v => v.type === ErrorType.DUPLICATED_FILE))) {
          this.updateValidationStatus(ErrorType.DUPLICATED_FILE, true, efile => efile.uid === duplicated[0].uid)
        }
      }
    },
    
    // #region CheckSchema Methods
    checkSchemaFileResponse (archivo, fileData) {
      const fileName = this.initializeSchemaFileResponse(archivo, fileData)

      if (!this.SchemaForType.includes(fileData.esquema)) {
        const msg = `${fileName}: ${i18n.t('feedback.error.not_valid_schema_for_tab_error', { fileType: i18n.t('invoices.issued_header') })}`
        setTimeout(() => this.doFeedback(msg), 100)
        this.addValidation(archivo, msg, ErrorType.SCHEMA_TYPE_ERROR)
        this.selectFile(archivo, true)
      }
      
      this.registerFileSchema(archivo, fileData)

      if (fileData.esquema === 'ZCPGE' || fileData.esquema === 'EXCEL') {
        if (!this.form.CifEmpresa) {
          setTimeout(() => this.doFeedback(`${fileName}: ${i18n.t('feedback.info.without_issuer_data_msg')}`, 'info'), 100)
          this.addWarning(archivo, i18n.t('tooltip.issued_zcpge_warn'), WarningType.MISSING_CIF)
        }
      }
      if (this.validateSchemaFileDetails(archivo, fileData, fileName)) {
        const validateNoMix = (value, selectedValue, message, errorType, target) => {
          if (value && selectedValue !== value) {
            setTimeout(() => this.doFeedback(message), 100)
            this.addValidation(target, message, errorType)
            this.selectFile(target, true)
          }
        }
        this.$set(archivo, 'isSigned', !!fileData.IsSigned)
        this.$set(archivo, 'IdCifEmpresa', fileData.IdCifEmpresaDetected || '')
        this.selectCif ||= archivo.IdCifEmpresa
        validateNoMix(
          archivo.IdCifEmpresa, 
          this.selectCif, 
          i18n.t('feedback.error.miscelaneus_cif_error'), 
          ErrorType.MISCELANEUS_CIF_ERROR, 
          archivo
        )

        const invoices = fileData.FileDetails.Invoices || []
        const hasMultipleInvoices = fileData.FileDetails.InvoicesToImport > 1
        const isMultipleFile = !!(this.tiposEsquema.find(x => x.esquema === fileData.esquema)?.multiple ?? false)
        if (hasMultipleInvoices) {
          this.$set(archivo, 'files', [])
          this.$set(archivo, 'isOpen', false)
        }
          
        for (const invoice of invoices) {
          const innerfile = hasMultipleInvoices ? {} : archivo
          this.$set(innerfile, 'pgeType', invoice.SendTypeSelected || '')
          this.selectPge ||= innerfile.pgeType
          validateNoMix(
            innerfile.pgeType, 
            this.selectPge, 
            i18n.t('feedback.error.miscelaneus_pge_error'), 
            ErrorType.MISCELANEUS_PGE_ERROR, 
            innerfile
          )
          if (isMultipleFile) {
            const idprop = hasMultipleInvoices ? 'linkid' : 'attachid'
            this.$set(innerfile, idprop, `${archivo.linkid}_${invoice.UniqueIdentifierInvoice}`)
            this.$set(innerfile, 'uid', archivo.uid)
            this.$set(innerfile, 'origin', `user.api.invoice.${innerfile.uid}`)
            this.$set(archivo, 'pgeType', archivo.pgeType || invoice.SendTypeSelected || '')
            this.$set(innerfile, 'IdCifEmpresa', fileData.IdCifEmpresaDetected || '')
            if (hasMultipleInvoices) {
              const name = invoice.InvoiceSeries
                ? `${invoice.InvoiceSeries}_${invoice.InvoiceNumber}`
                : `${invoice.InvoiceNumber}`
  
              this.$set(innerfile, 'name', name)
            }
          }
          this.$set(innerfile, 'reqAttachments', invoice.RequestedAttachments)
          this.checkAttachmentsFileResponse(innerfile, invoice.RequestedAttachments)
          if (hasMultipleInvoices)archivo.files.push(innerfile)
        }

        this.$nextTick(() => {
          const empresa = this.cifEmpresaSelected
          const missingVerifactuConfig = empresa?.HasVerifactuActive && !empresa.HasCertificateActive
          let feedbackMsg = ''
          if (empresa && missingVerifactuConfig) {
            feedbackMsg = i18n.t('feedback.error.missing_signature_config_for_verifactu_error', { name: empresa.RazonSocial })
          }
          const msg = i18n.t('invoices.dialogs.upload_invoice_file_require_signature')
          const requireSignatureConfig = !empresa?.HasCertificateActive && 
            !this.noSignatureConfig.includes(this.form.pgeType) &&
            !archivo.isSigned
          if (empresa && requireSignatureConfig) {
            feedbackMsg = i18n.t('feedback.error.missing_signature_config_for_pge_error', { name: empresa.RazonSocial })
          }
          const fixed = (!empresa || !this.form.pgeType) || !missingVerifactuConfig || !requireSignatureConfig
          if (!fixed) this.openSignatureDialog(feedbackMsg)
          this.addValidation(archivo, msg, ErrorType.MISSING_SIGNATURE_CONFIG_ERROR, msg, fixed)
        })
          
        if (hasMultipleInvoices && archivo.files?.some(x => x.warns?.length)) {
          this.addWarning(archivo, i18n.t('tooltip.issued_any_childfile_warns'), WarningType.MIXED_WARNING, archivo.files.every(x => x.warns?.every(w => w.fixed) ?? true))
        }
      }
      this.setSchemaChildPaths(archivo)
    },
    
    // #endregion
    
    showAddAttachments: function (efile) {
      return !efile.files?.length && (this.isFileSuccess(efile) || this.isFileWarn(efile))
    },
    resetForm: function () {
      this.resetFormFiles()
      this.form.sendAuto = false
      this.form.sendMail = false
      this.form.pgeType = ''
      this.form.CifEmpresa = ''
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate()
      }
    },
    initialiceData: async function () {
      this.resetAllForm()
      if ([8, 3].includes(this.role)) {
        const dataClients = await getClients()
        if (dataClients.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
        }
        this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
        this.form.ClienteID = this.clientFilter || ''
      } else {
        this.form.ClienteID = this.getIdEmpresaLogged || ''
      }
      // if (this.isSignatureConfig) {
      //   const data = this.$store.getters['uploadInvoiceDialog/uploadData']
      //   if (data) {
      //     this.tabSelected = data.tabSelected || 'issued'
      //     if (data.form) {
      //       for (const key in data.form) {
      //         if (!Object.hasOwn(data.form, key) || !Object.hasOwn(this.form, key)) continue
      //         this.form[key] = data.form[key]
      //       }
      //     }
      //     if (data.schemasFiles) {
      //       for (const key in data.schemasFiles) {
      //         if (!Object.hasOwn(data.schemasFiles, key) || !Object.hasOwn(this.schemasFiles, key)) continue
      //         this.schemasFiles[key] = data.schemasFiles[key]
      //       }
      //     }
      //     this.form.ClienteID = data.form.ClienteID
      //     this.receivedForm.ClienteID = data.form.ClienteID
      //     this.verifactuForm.ClienteID = data.form.ClienteID
      //   }
      //   this.$store.dispatch('app/exitMode', 6)
      // }
      if (this.form.ClienteID) {
        this.updateClientCifs(this.form.ClienteID)
      }
      this.selectedFile = null
      this.selectCif = ''
      this.selectPge = ''
    },
    submitForm: async function (ruleForm) {
      const noWarnings = !this.warningError || (this.isWarningFixed(this.form.fileMain) && this.isWarningFixed(this.form.file))
      const noValidations = !this.validationError || (this.isValidationFixed(this.form.fileMain) && this.isValidationFixed(this.form.file))
      if (noValidations && noWarnings) {
        this.uploadInvoice(ruleForm)
      } else if (!noWarnings) {
        this.doFeedback(i18n.t('feedback.error.process_data_error'), 'warning')
      } else {
        this.doFeedback(i18n.t('feedback.error.process_data_error'))
      }
    },
    uploadInvoice: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            this.isLoadingUpdate = true
            const files = this.form.fileMain.concat(this.form.file)
            const params = {
              pgeType: this.form.pgeType || null,
              enviarAuto: !!this.form.sendAuto,
              enviarMail: !!this.form.sendMail,
              multiSend: !!this.multiSend,
              idCIFEmpresa: this.form.CifEmpresa || null,
              idCliente: 0,
            }
            if ([3, 8].includes(this.role)) {
              params.idCliente = this.form.ClienteID
            }
            if (this.multiSend) {
              subirFactura(files, params).then(response => {
                if (response.blnError === true) {
                  this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response), response.codError === 'FCSF012' ? 'warning' : 'error')
                } else {
                  this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 2), 'success')
                  this.initialiceData()
                }
                this.$emit('applyDialog', { results: response.Respuestas })
              }).catch(() => {
                this.doFeedback(i18n.t('feedback.error.internal_error_message'))
                this.$emit('applyDialog', {})
              }).finally(() => { this.isLoadingUpdate = false })
              this.resetForm()
              this.resetSchemasFiles()
              this.$emit('applyDialog', { background: true })
            } else {
              const response = await subirFactura(files, params)
              if (response.blnError === true) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.resetForm()
                this.resetSchemasFiles()
                this.$emit('applyDialog', {})
                this.doFeedback(i18n.tc('feedback.success.invoices_uploaded_msg', 1), 'success')
                this.initialiceData()
              }
              this.isLoadingUpdate = false
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    updateClientCifs: async function (idCliente) {
      this.loading = true
      this.$store.commit('setIsLoading', true)
      const res = await getcifspermisos({ idCliente })
      if (res.blnError) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        this.CifsEmpresa = []
      } else {
        this.CifsEmpresa = res.CIFSEmpresa
      }
      this.loading = false
      this.$store.commit('setIsLoading', false)
    },
    cifLabelOption: function (option) {
      return option.RazonSocial
    },
    cifValueOption: function (option) {
      return option.IdCIFEmpresa
    },
    gotoSignatureConfig: function () {
      // const data = cloneDeep(this.preserve(['schemasFiles', 'form', 'tabSelected'], this))
      // this.$store.commit('uploadInvoiceDialog/setUploadData', data)
      // this.$store.dispatch('app/enterMode', 6)
      this.redirectTo({ 
        name: 'companies/config',
        params: { 
          id: this.form.CifEmpresa
        } 
      }).then(() => this.$emit('toggleDialog'))
    },
    openSignatureDialog: function (msg = '', feedbackType = 'error') {
      if (!this.showModal && !this.waitingToShow) {
        this.waitingToShow = true
        if (msg) setTimeout(() => this.doFeedback(msg, feedbackType), 100)
        setTimeout(() => {
          this.showModal = true
          this.waitingToShow = false
        }, 500)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await descargarficherofacturasexcel()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-subida-facturas-InvoiZE.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#fileMainSelector::v-deep .el-upload-list {
  max-height: 67px !important;
}

::v-deep .el-upload-list__item:first-child {
  margin-top: 5px;
}

.upload-file-list {
  padding-bottom: 0;
}

.all-attachments-container .upload-file-list ::v-deep .upload-file-list--item {
  margin-top: unset;
  margin-bottom: unset;
}
.main-files-container, .file-attachments-container {
  height: fit-content;
}
.all-attachments-container {
  max-height: 345px;
}

.el-form-item {
  margin-bottom: 0;
}

@media (min-width: 1024px) {
  .all-attachments-container .upload-file-list.grid-cols-2 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .all-attachments-container .upload-file-list.grid-cols-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1680px) {
  .all-attachments-container .upload-file-list.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .all-attachments-container .upload-file-list.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
